export default __webpack_public_path__ + "static/media/flickr.d0b7c18e.svg";